/* VikTools global helpers. Loaded with defer from snippets/vt-head.liquid. */
(function () {
  'use strict';

  /* ---------- Scroll reveal ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.vt-reveal:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Add to cart ----------
     Prefers Shopify standard actions (Horizon listens to the resulting cart events and refreshes/opens
     its drawer). Falls back to the AJAX cart API and a redirect to /cart. */
  function addToCart(variantId, quantity, button) {
    quantity = quantity || 1;
    if (button) { button.classList.add('is-loading'); button.setAttribute('aria-busy', 'true'); }
    var done = function () { if (button) { button.classList.remove('is-loading'); button.removeAttribute('aria-busy'); } };
    var actions = window.Shopify && window.Shopify.actions;
    var p;
    if (actions && actions.updateCart) {
      p = actions.updateCart(
        { lines: [{ merchandiseId: String(variantId), quantity: quantity }] },
        { event: { context: 'product' } }
      ).then(function (res) {
        if (res && res.userErrors && res.userErrors.length) throw new Error(res.userErrors[0].message);
        if (actions.openCart) return actions.openCart();
      });
    } else {
      p = fetch((window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity }] })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add to cart'); });
        window.location.href = '/cart';
      });
    }
    return p.then(done, function (err) {
      done();
      if (button) {
        var msg = button.parentElement && button.parentElement.querySelector('[data-vt-cart-error]');
        if (msg) { msg.textContent = err && err.message ? err.message : 'Could not add to cart'; msg.hidden = false; }
      }
      console.warn('[vt] add to cart failed', err);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vt-add]');
    if (!btn) return;
    e.preventDefault();
    var scope = btn.closest('[data-vt-product]') || document;
    var select = scope.querySelector('[data-vt-variant]');
    var qtyInput = scope.querySelector('[data-vt-qty]');
    var id = (select && select.value) || btn.getAttribute('data-vt-add');
    var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
    if (id) addToCart(id, qty, btn);
  });

  /* ---------- Looping videos: load and play only while visible ---------- */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var videoIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        if (v.preload === 'none') { v.preload = 'auto'; }
        if (!reduceMotion) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      } else if (!v.paused) { v.pause(); }
    });
  }, { rootMargin: '200px 0px', threshold: 0.15 }) : null;
  function initVideos(root) {
    (root || document).querySelectorAll('video[data-vt-autoplay]:not([data-vt-seen])').forEach(function (v) {
      v.setAttribute('data-vt-seen', '');
      v.muted = true;
      if (videoIO) videoIO.observe(v); else { v.preload = 'auto'; v.play && v.play().catch(function () {}); }
    });
  }

  /* ---------- Money formatting for client-side price displays ---------- */
  function money(cents) {
    var fmt = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: fmt }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  window.vt = { addToCart: addToCart, reveal: initReveal, videos: initVideos, money: money };

  function boot(root) { initReveal(root); initVideos(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
